require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./goals-be-healthy.json") })
        }
      }, "path---goals-be-healthy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---goals-be-healthy!./.cache/json/goals-be-healthy.json
// module id = 356
// module chunks = 231608221292675